import { render, staticRenderFns } from "./CustomLink.vue?vue&type=template&id=2a9a4566&"
import script from "./CustomLink.vue?vue&type=script&lang=ts&"
export * from "./CustomLink.vue?vue&type=script&lang=ts&"
import style0 from "./CustomLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports